import React, { useEffect, useState } from 'react';
import FirmaPad from './FirmaPad';
import api from '../../services/api';

// Firmas al cerrar un trabajo (16-oct-2026), para los cierres que no las tenían
// (registrar trabajo de una visita, cerrar por N/S). La del técnico se toma de la guardada.
// value: { firmaTecnico, firmaCliente }; onChange(nuevo)
export function firmaGuardada() {
    try { return JSON.parse(localStorage.getItem('auth_usuario') || '{}').firma || null; } catch { return null; }
}

export default function FirmasCierre({ value, onChange }) {
    const [editando, setEditando] = useState(!firmaGuardada());
    useEffect(() => {
        const g = firmaGuardada();
        if (g && !value?.firmaTecnico) onChange({ ...value, firmaTecnico: g });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const guardarMia = () => {
        if (!value?.firmaTecnico) return;
        try {
            const u = JSON.parse(localStorage.getItem('auth_usuario') || '{}');
            localStorage.setItem('auth_usuario', JSON.stringify({ ...u, firma: value.firmaTecnico }));
        } catch { /* */ }
        api.patch('/auth/mi-firma', { firma: value.firmaTecnico }).catch(() => {});
        setEditando(false);
    };

    return (
        <div className="space-y-2">
            {!editando && value?.firmaTecnico ? (
                <div className="flex items-center gap-2 px-3 py-2.5 rounded-xl bg-card">
                    <span className="text-caption font-bold text-[#16A34A]">✓ Firma del técnico guardada</span>
                    <button type="button" onClick={() => setEditando(true)} className="ml-auto text-label font-bold text-muted">Cambiar</button>
                </div>
            ) : (
                <div className="space-y-1.5">
                    <FirmaPad label="Firma del técnico" value={value?.firmaTecnico} onChange={v => onChange({ ...value, firmaTecnico: v })} height={100} />
                    <div className="flex items-center gap-2">
                        <button type="button" onClick={guardarMia} disabled={!value?.firmaTecnico}
                            className="text-label px-3 py-1.5 rounded-full bg-brand-red text-white font-bold disabled:opacity-40 active:scale-95">Guardar mi firma</button>
                        <span className="text-caption text-muted">Queda para las próximas</span>
                    </div>
                </div>
            )}
            <FirmaPad label="Firma del cliente (opcional)" value={value?.firmaCliente} onChange={v => onChange({ ...value, firmaCliente: v })} height={140}
                aclaracion={value?.aclaracionCliente} onAclaracion={v => onChange({ ...value, aclaracionCliente: v })} />
        </div>
    );
}
